export default __webpack_public_path__ + "static/media/nctEditIcon.195d2350.svg";